module.exports = __webpack_public_path__ + "media/images/sp/icon-menu-773c152fe45200b094539cfc805607e2.png";